<template>
  <section id="section__main" class="pt-6 pb-10">
    <div v-if="meLoading === false && me" class="view-container">
      <MallAuthDialog v-if="show" :mallLimit="showMallLimit" @emitClose="closeDialog" />
      <v-card flat class="pa-0" width="100%">
        <v-card-title class="pa-0 mb-3">
          <div class="welcome-text">
            <p class="font--m-3 mb-1 text-left">
              안녕하세요.
              <v-chip
                small
                color="pink lighten-4"
                text-color="black"
                :to="{ path: '/my/plans' }"
                v-if="me.planChoice"
              >
                {{ me.planChoice.plan.name }}
              </v-chip>
              <ContractStatus>
                <template
                  #default="{ isCompleted, isSigned }"
                  v-if="me.storeSet.length > 0 && me.businessSet.length > 0"
                >
                  {{ me.storeSet[0].name }} {{ me.businessSet[0].ownerName }}님
                  <template v-if="!isCompleted && !isSigned && isCreditAvailable">
                    <v-chip
                      small
                      color="yellow"
                      text-color="black"
                      :to="{ path: '/my/contract/management' }"
                    >
                      계약서 작성필요
                    </v-chip>
                  </template>
                </template>
              </ContractStatus>
            </p>
            <div v-for="mall in providers" :key="mall.code">
              <router-link
                id="btn__DTSomn7ZlUS5Iok+XNcQ/A=="
                v-if="wrongCredentials.some((v) => v.mall.provider === mall.code)"
                :to="{
                  path: `/my/malls/${mallsObj[mall.code].uuid}/form`,
                }"
                style="text-decoration: underline black"
              >
                <p class="font--m-5" v-if="wrongCredentials.length > 0">
                  <strong>[{{ mall.name }}]</strong> 정보 변경으로 확인이 필요한 계정이 있어요.
                </p>
              </router-link>
              <a
                id="btn__f8VZQ/r8fkm6R6w+4HXAGQ=="
                v-else-if="is2faRequireds.some((v) => v.mall.provider === mall.code)"
                @click="propsMallLimit(is2faRequireds.find((v) => v.mall.provider === mall.code))"
                style="text-decoration: underline black; text-decoration-thickness: 1px"
              >
                <span class="font--m-5"
                  ><strong>[{{ mall.name }}]</strong> 2차 인증이 안돼서 한도가 적게 나와요!
                  [인증하기]</span
                >
              </a>
              <a v-else></a>
            </div>
          </div>
        </v-card-title>

        <v-row no-gutters>
          <v-col cols="12" class="mt-3 mb-3">
            <MainCard />
          </v-col>

          <v-col cols="12" class="mb-3">
            <MoreAvailableAmount
              v-if="me && me.planChoice && availableAmount.plans"
              :plan="me.planChoice.plan"
              :plans="availableAmount.plans"
            />
          </v-col>

          <v-col cols="12">
            <RemittanceHistory />

            <!-- 송금 실패 안내 얼럿 -->
            <PaymentFailedNoticeModal />

            <!-- 거절 상태 유저 모달 -->
            <RejectedUserModal />
          </v-col>
        </v-row>
      </v-card>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import MainCard from '@/components/main/MainCard.vue'
import RemittanceHistory from '@/components/main/RemittanceHistory.vue'
import MallAuthDialog from '@/components/mall/MallAuthDialog.vue'
import ContractStatus from '@/components/main/status/ContractStatus.vue'
import MoreAvailableAmount from '@/components/main/MoreAvailableAmount.vue'

export default {
  components: {
    MainCard,
    RemittanceHistory,
    MallAuthDialog,
    ContractStatus,
    MoreAvailableAmount,
    PaymentFailedNoticeModal: () => import('@/components/main/PaymentFailedNoticeModal.vue'),
    RejectedUserModal: () => import('./RejectedUserModal.vue'),
  },
  data() {
    return {
      providers: null,
      show: false,
      showMallLimit: null,
    }
  },
  async created() {
    this.providers = await this.getMallProviders()
    await this.getPlans()
  },
  computed: {
    ...mapGetters('mall', ['mallsObj']),
    ...mapGetters('auth', ['isCreditAvailable']),
    ...mapState('auth', ['me', 'meLoading']),
    ...mapState('bnpl', ['availableAmount', 'wrongCredentials', 'is2faRequireds']),
  },
  methods: {
    ...mapActions('mall', ['getMallProviders']),
    ...mapActions('bnpl', ['getAvailableAmount']),
    ...mapActions('plans', ['getPlans']),
    isPossibleAlert() {
      this.$swal.basic.alert({
        html: `<b class="font--m-5">계약서 작성 필요 <br /> <br /> 전자계약서가 발송될 예정입니다. <br/> 서명을 완료하시면 <br /> 서비스 이용이 가능합니다. </b>`,
        icon: 'warning',
        iconColor: '#FFD233',
        showConfirmButton: false,
        showCloseButton: true,
      })
    },
    closeDialog() {
      setTimeout(() => {
        this.show = false
      }, 50)
    },
    propsMallLimit(temp) {
      this.showMallLimit = temp
      this.show = true
    },
  },
}
</script>

<style lang="scss" scoped>
#section__main {
  height: 80%;
  padding-left: 15px;
  padding-right: 15px;
}

.welcome-text {
  p {
    line-height: 1.5;
  }
}

.selector__enter {
  min-height: 110px;

  border: 1px solid $gray-80;
  border-radius: $border-radius-default;
  box-shadow: 3px 3px 10px 3px rgba(23, 25, 26, 0.2);
  text-align: left;

  padding: 15px;

  &.btn--green {
    border-color: green;

    p {
      color: $white !important;
    }
  }
}
.rounded-card {
  background-color: $gray-15;
  border-radius: 10px;
  width: 100%;
}
</style>
